import MainContinent from './MainContinent';
export default MainContinent;



// WEBPACK FOOTER //
// ./src/components/Continent/MainContinent/index.js